import { Cpu, Zap, ShieldCheck } from "lucide-react";

const items = [
  {
    icon: Cpu,
    label: "3 Mesin Komputer",
    sub: "12 + 6 + 1 kepala",
  },
  {
    icon: Zap,
    label: "19 Kepala Mesin",
    sub: "Produksi paralel & cepat",
  },
  {
    icon: ShieldCheck,
    label: "Sanggup Partai Besar",
    sub: "Tetap melayani satuan",
  },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="bg-[#4A3B2F] text-[#F9F6F0] border-y border-[#2C2621]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {items.map((it, idx) => (
            <div
              key={idx}
              data-testid={`trust-item-${idx}`}
              className="flex items-center gap-4 justify-center md:justify-start"
            >
              <div className="shrink-0 w-11 h-11 rounded-full bg-[#C97A4E]/20 border border-[#C97A4E]/30 flex items-center justify-center">
                <it.icon className="w-5 h-5 text-[#E8B796]" />
              </div>
              <div>
                <div className="font-heading font-semibold text-base md:text-lg leading-tight">
                  {it.label}
                </div>
                <div className="text-xs md:text-sm text-[#E5D9C5]/80 mt-0.5">
                  {it.sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
